/**
 * The Disposable contract.
 *
 * Implemented by objects that can free internal resources.
 *
 * @interface
 */

export class Disposable {

	/**
	 * Frees internal resources.
	 */

	dispose() {}

}



// WEBPACK FOOTER //
// ./node_modules/postprocessing/src/core/Disposable.js